import React     from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import * as S from './prod-name.module.scss';


const ProductName = ({name, className}) => {
  return (
    <div className={ClassNames(S.prodName, className)}>{name}</div>
  );
};

ProductName.displayName = 'CompanyBox';
ProductName.propTypes   = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};

export { ProductName };
